import type { Work } from './manifest';
import { pick } from './i18n';

const SITE = 'https://moser.ink';
const DEFAULT_TITLE = 'moser.ink — inside the head';
const DEFAULT_DESC = 'MOSER — ink & digital art. Step inside the head.';

function setMeta(attr: 'name' | 'property', key: string, content: string): void {
  const sel = `meta[${attr}="${key}"]`;
  let el = document.querySelector(sel) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = content;
}

/** Update Open Graph / Twitter tags for the current view. */
export function updateOgTags(work?: Work): void {
  if (!work) {
    document.title = DEFAULT_TITLE;
    setMeta('property', 'og:title', DEFAULT_TITLE);
    setMeta('property', 'og:description', DEFAULT_DESC);
    setMeta('property', 'og:image', `${SITE}/og-default.jpg`);
    setMeta('property', 'og:url', location.href);
    setMeta('name', 'twitter:title', DEFAULT_TITLE);
    setMeta('name', 'twitter:description', DEFAULT_DESC);
    return;
  }

  const title = pick(work.title) || 'MOSER';
  const pageTitle = `${title} — moser.ink`;
  const desc = pick(work.description, DEFAULT_DESC);
  const image = `${location.origin}${import.meta.env.BASE_URL}textures/${work.id}-l.webp`;

  document.title = pageTitle;
  setMeta('property', 'og:title', pageTitle);
  setMeta('property', 'og:description', desc);
  setMeta('property', 'og:image', image);
  setMeta('property', 'og:url', location.href);
  setMeta('name', 'twitter:title', pageTitle);
  setMeta('name', 'twitter:description', desc);
  setMeta('name', 'twitter:image', image);
}

export function shareUrl(params: Record<string, string>): string {
  const url = new URL(location.href);
  for (const [k, v] of Object.entries(params)) url.searchParams.set(k, v);
  return url.toString();
}

/** Remove ?work= from the address bar after closing detail view. */
export function clearWorkUrl(): void {
  const url = new URL(location.href);
  if (!url.searchParams.has('work')) return;
  url.searchParams.delete('work');
  history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
}
